import propTypes from 'prop-types';
import ActionButton from '../ActionButton';
import FacialRegisteredContent from '../FacialRegisteredContent';
import HostMessage from '../HostMessage';
import * as S from './styles';

const FaceRegisterActionArea = ({
  hasFacialRegistered,
  facialPhoto,
  userName,
  eventTitle,
  hostMessage,
  headingColor,
  primaryColor,
  onOpenEditModal,
}) => (
  <S.Container>
    <S.Heading>
      <S.InviteTitle $color={headingColor}>{eventTitle}</S.InviteTitle>
      {hostMessage && (
        <HostMessage message={hostMessage} color={headingColor} />
      )}
    </S.Heading>
    {hasFacialRegistered ? (
      <FacialRegisteredContent
        facialPhoto={facialPhoto}
        userName={userName}
        primaryColor={primaryColor}
        textColor={headingColor}
        onOpenEditModal={onOpenEditModal}
      />
    ) : (
      <ActionButton primaryColor={primaryColor} />
    )}
  </S.Container>
);

FaceRegisterActionArea.propTypes = {
  hasFacialRegistered: propTypes.bool,
  facialPhoto: propTypes.string,
  userName: propTypes.string,
  eventTitle: propTypes.string,
  hostMessage: propTypes.string,
  headingColor: propTypes.string,
  primaryColor: propTypes.string,
  onOpenEditModal: propTypes.func,
};

FaceRegisterActionArea.defaultProps = {
  hasFacialRegistered: false,
  facialPhoto: '',
  userName: '',
  eventTitle: '',
  hostMessage: '',
  headingColor: undefined,
  primaryColor: undefined,
  onOpenEditModal: () => {},
};

export default FaceRegisterActionArea;
